import { uebersetze } from '../../i18n/sprache.js';

/* Die Vorgabe war 'Nothing here yet' - englisch, in einer Anwendung, die auf
   Deutsch, Englisch und Französisch läuft. Wer keine eigene Meldung mitgibt,
   bekommt jetzt die übersetzte Vorgabe. */
export function EmptyState({ message, children }) {
  return (
    <div className="empty-state">
      <strong>{message || uebersetze('empty.default')}</strong>
      {children}
    </div>
  );
}
